import { useMemo } from 'react';
import clsx from 'clsx';
import parse from 'html-react-parser';
import {
  Paragraph,
  ChefHat,
  DullLightBulb,
  SnowFlake,
} from '@hungryroot/ui-kit';
import {
  ProteinSourcingDisclosure,
  type ProteinSourcingVariant,
} from '../ProteinSourcingDisclosure/ProteinSourcingDisclosure';
import styles from './AdditionalProductInfo.module.css';

interface Props {
  description?: string;
  refrigerate?: boolean;
  instructions?: string;
  // this is an HTML string
  tip?: string;
  proteinSourcing?: ProteinSourcingVariant[];
}

export function AdditionalProductInfo(props: Props) {
  const {
    description,
    refrigerate,
    instructions,
    tip,
    proteinSourcing = [],
  } = props;

  const parsedDescription = useMemo(() => {
    if (description === undefined) {
      return undefined;
    }
    return parse(description);
  }, [description]);

  const parsedTip = useMemo(() => {
    if (tip === undefined) {
      return undefined;
    }
    return parse(tip);
  }, [tip]);

  return (
    <div className={styles.container}>
      {parsedDescription && (
        <div className={styles.description}>
          <Paragraph>{parsedDescription}</Paragraph>
        </div>
      )}
      {proteinSourcing.length > 0 && (
        <div className={styles['protein-sourcing-disclosure']}>
          {proteinSourcing.map((variant) => (
            <ProteinSourcingDisclosure key={variant} variant={variant} />
          ))}
        </div>
      )}
      {refrigerate && (
        <div className={styles.row}>
          <SnowFlake />
          <Paragraph className={styles.text}>Refrigerate</Paragraph>
        </div>
      )}
      {instructions && (
        <div className={styles.row}>
          <ChefHat />
          <Paragraph className={clsx(styles.text, styles['parsed-html'])}>
            {parse(instructions)}
          </Paragraph>
        </div>
      )}
      {parsedTip !== undefined ? (
        <div className={styles.row}>
          <DullLightBulb />
          <Paragraph className={clsx(styles.text, styles['parsed-html'])}>
            <span className={styles['tip-label']}>Tip:</span> {parsedTip}
          </Paragraph>
        </div>
      ) : null}
    </div>
  );
}
